import PropTypes from 'prop-types';

import Button, { ButtonAppearance } from 'bloko/blocks/button';
import ClickMenu, { MenuPlacement } from 'bloko/blocks/drop/Menu/Click';
import Icon, { IconColor, IconScale, IconView } from 'bloko/blocks/icon';
import Loading, { LoadingScale } from 'bloko/blocks/loading';

import MenuItems from 'components/BanerAdminActions/MenuItems';

import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

import 'components/BanerAdminActions/BanerAdminActions.less';

const BanerAdminActions = ({ campaignId, bannerId }) => {
    const sessionType = useSelector((state) => state.user.sessionType);
    const { bannerId: bannerIdForModeration, isLoad } = useSelector((state) => state.adminBannerAction);

    if (sessionType !== SessionType.Sudo) {
        return null;
    }
    return (
        <div className="banner-moderation">
            <ClickMenu
                render={(close) => <MenuItems campaignId={campaignId} bannerId={bannerId} close={close} />}
                placement={MenuPlacement.BottomEnd}
            >
                <Button
                    appearance={ButtonAppearance.Outlined}
                    loading={
                        isLoad && bannerId === bannerIdForModeration ? <Loading scale={LoadingScale.Small} /> : null
                    }
                    icon={<Icon view={IconView.Bars} initial={IconColor.Gray60} scale={IconScale.Small} />}
                />
            </ClickMenu>
        </div>
    );
};

BanerAdminActions.propTypes = {
    campaignId: PropTypes.number,
    bannerId: PropTypes.number,
};

export default BanerAdminActions;
